import type { Warning } from '@/components/common/WarningIcon'
import type { ApiVaultWarning } from '@/helpers/warningTypes'

import { getVaultWarningMessage } from '@/helpers/warningMessages'

import { apiWarningLevelToEnum, getVaultWarningScrollType } from './warnings'

// Detail surfaces only (VaultHero). `warningType` makes hover-card rows clickable and scrolls
// to a section id that only exists on the vault page, so the vault list surfaces build their
// `Warning[]` inline without it rather than calling this.
export function aggregateVaultV1Warnings(vaultWarnings: ApiVaultWarning[] | undefined): Warning[] {
  const warnings: Warning[] = []

  for (const warning of vaultWarnings ?? []) {
    // Market-sourced rows are ignored: `getVaultWarningMessage` returns null for them.
    const message = getVaultWarningMessage(warning)
    if (!message) continue

    warnings.push({
      level: apiWarningLevelToEnum(warning.level),
      message,
      warningType: getVaultWarningScrollType(warning.type)
    })
  }

  return warnings
}
